import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { DashboardState } from './state';
import {defaultParams} from '@/store/dashboard/initialParams';

const defaultState: DashboardState = {
  dashboardLessons: [],
  newBook: null,
  flowsStats: {},
  nearestEvents: [],
};

export const dashboardModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
